// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"573f067b","239":"50b24b4a","455":"99e1e400","977":"a7e57e72"}[chunkId] + ".chunk.js";
};